/**
 * Add an error to DataDog RUM with optional context.
 * In development (when DD_RUM is not available), logs to console instead.
 *
 * For React components, prefer using `useDatadogRum()` hook which includes user context.
 * This utility is for use in class components (like error boundaries) where hooks aren't available.
 */
export const addError = (error: Error, context?: Record<string, unknown>) => {
	const RumGlobal = window.DD_RUM;

	if (RumGlobal) {
		// Production/staging: send to DataDog RUM
		RumGlobal.addError(error, context);
	} else if (import.meta.env.REACT_APP_ENV === 'development') {
		// Development fallback: log to console when DD_RUM isn't available
		// eslint-disable-next-line no-console
		console.error(`Bonusly Telemetry: ${error.message}`, context);
	}
};
